module.exports = __webpack_public_path__ + "static/media/1-min.71d4d805.png";